import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { ExternalNetworksSettingsLoadActions } from '../../domains/externalNetworks/actions.types';

import type { ExternalNetworksLifeCycle } from './types';

const initialState: ExternalNetworksLifeCycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<ExternalNetworksLifeCycle, ExternalNetworksSettingsLoadActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'EXTERNAL_NETWORKS_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'EXTERNAL_NETWORKS_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'EXTERNAL_NETWORKS_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
